import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 0.5rem 1rem;
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Cell = styled.div`
  padding: 0.5rem 0.5rem;
  flex-grow: 1;
  flex-basis: 0;
  color: #7e7e7e;
  font-size: 0.625rem;
  font-weight: 600;
  text-align: center;
`;
